import React from 'react'
import { Button, Input } from '@/shared/ui'

type Props = {
  month: string
  onMonthChange: (v: string) => void
  onRefresh: () => void
  loading?: boolean
}

export function FinanceHeader({ month, onMonthChange, onRefresh, loading }: Props) {
  return (
    <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div className="space-y-1">
        <h1 className="bg-gradient-to-r from-emerald-300 via-cyan-300 to-sky-400 bg-clip-text text-3xl font-semibold text-transparent">
          Financeiro
        </h1>
        <p className="text-sm text-foreground/70">
          Receita (Stripe) + custos + payouts de afiliados, com “última linha” mensal.
        </p>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground/70">Mês</span>
          <Input
            type="month"
            value={month}
            onChange={(e) => onMonthChange((e.target as HTMLInputElement).value)}
            className="h-10 w-[160px]"
          />
        </div>
        <Button onClick={onRefresh} disabled={!!loading}>
          {loading ? 'Atualizando...' : 'Atualizar'}
        </Button>
      </div>
    </div>
  )
}

